const REDIRECT_MESSAGE = "That contact isn't available to view yet as its fact find hasn't been submitted.";

/**
 * Blocks the client details page (and every sub-page under pages/contacts/_id/)
 * for "provisional fact find" skeleton accounts — the placeholder client records
 * created when a user is added within a fact find that hasn't been submitted yet.
 * These records are hidden everywhere else in the app, so reaching one directly
 * (a bookmark, a stale link, or a seeded store) bounces the user back to the
 * contact list with an explanatory toast.
 */
export default async function ({ store, params, redirect }) {
  const alreadyLoaded = store.state.client.client?.uuid === params.id;

  if (!alreadyLoaded) {
    await store.dispatch('client/refreshClient', { client_uuid: params.id });
  }

  const client = store.state.client.client;

  if (client?.uuid === params.id && client.is_pending_fact_find_account) {
    // Drop the skeleton from the store so it can't linger and affect the list view.
    store.commit('client/CLEAR_CLIENT');

    const notify = () => {
      if (window.$nuxt) {
        window.$nuxt.$emit('notification', REDIRECT_MESSAGE, 'warning', true);
      } else {
        setTimeout(notify, 100);
      }
    };
    setTimeout(notify, 300);

    return redirect('/contacts');
  }
}
